import React, { Component } from "react";
import NavEN from "../Symbols/NavEN";
import { Link } from "react-router-dom";
import FooterEN from "../Symbols/FooterEN";
import AS_OV from "../../assets/as_p.jpg";
import AS1 from "../../assets/as_1.jpg";
import AS2 from "../../assets/waterpump.png";
import AS3 from "../../assets/toilette.png";
import AS4 from "../../assets/e-bike.png";
import AS5 from "../../assets/fan_2.png";
import AS6 from "../../assets/zapfsaeule.png";
import AS2_1 from "../../assets/pd_1.png";
import AS2_2 from "../../assets/AS2_2.png";
import AS2_3 from "../../assets/AS2_3.png";
import AS2_4 from "../../assets/AS2_4.jpg";
import { Helmet } from "react-helmet-async";
import "../../stylesheets/AboutUs.css";

class AutomotiveSolutions_New_EN extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: "PD",
      active_2: "S",
    };
    this.intro = React.createRef();
  }

  introScroll = () => {
    let element = this.intro.current;
    let headerOffset = 45;
    let elementPosition = element.getBoundingClientRect().top;
    let offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  changeCountry = (e, target) => {
    this.setState({
      active: target,
    });
  };

  changeCountry2 = (e, target) => {
    this.setState({
      active_2: target,
    });
  };

  render() {
    return (
      <div className="content">
        <Helmet>
          <title>Pancon - Automotive Solutions</title>
          <meta
            name="description"
            content="Discover high-quality connectors and innovative connectivity solutions from Pancon – precise, reliable, and ideal for automotive and industrial applications. Customized connectors for your requirements."
          />
          <meta property="og:title" content="Pancon - Automotive Solutions" />
          <meta
            property="og:description"
            content="Discover high-quality connectors and innovative connectivity solutions from Pancon – precise, reliable, and ideal for automotive and industrial applications. Customized connectors for your requirements."
          />
          <link
            rel="alternate"
            href="https://www.pancon.de/de/automotive-solutions"
            hrefLang="de"
          ></link>
          <link
            rel="alternate"
            href="https://www.pancon.de/en/automotive-solutions"
            hrefLang="en"
          ></link>
        </Helmet>
        <NavEN />
        <div className="hero auto-sol">
          <div className="red-bg-hero"></div>
          <div className="hero-content new">
            <h1 className="hero-heading">Custom Solutions</h1>
            <h2 className="hero-heading-2">Precision and Reliability for Your Industry</h2>
            <p className="hero-desc new">
              Welcome to Pancon, your partner for innovative connectivity solutions. With decades of experience, we develop customized connectors and components that meet the highest quality standards and perform reliably even in the most demanding applications.
            </p>
            <button onClick={this.introScroll} className="default inverted">
              Learn More
            </button>
          </div>
        </div>
        <div ref={this.intro} id="intro" className="section first flex center-h">
          <div className="medium flex">
            <div className="heading1-cont flex center-v">
              <h2 className="alternate-heading">Innovative Connectivity Solutions for the Automotive Industry</h2>
            </div>
            <p className="body padding-default no-marg">
              Pancon Connectors is your reliable partner for high-performance and dependable connectivity technologies in the automotive sector. Our specially developed connectors and control components contribute to the efficiency, safety, and performance of modern vehicles – from comfortable interior electronics to critical drive systems. Our automotive solutions include:
            </p>
            <ul className="body padding-default as-new-b">
              <li>Electronics & Comfort: Solutions for electric window regulators, mirror lighting, and audio amplification.</li>
              <li>Vehicle Safety: High-temperature connectors for differential systems and control units for LED lighting.</li>
              <li>High-performance connectivity: Board-to-board connectors for onboard charging systems and AdBlue injection for sustainable vehicle technologies.</li>
              <li>Customized Adaptation: Tailor-made connections for HVAC systems, pedals, and control units in steering wheels.</li>
            </ul>
            <p className="body padding-default as-new">
              Thanks to our expertise in the automotive industry, we deliver robust, durable, and precisely manufactured connectivity solutions that meet the highest quality and safety standards. <br />Discover our products and help drive the future of mobility with Pancon Connectors!
            </p>
            <div className="all-thirds-container flex">
              <img className="img-full" src={AS_OV}></img>
            </div>
          </div>
        </div>
        <div className="section flex center-h dir-change">
          <div className="medium flex">
            <div className="heading1-cont flex center-v center-h">
              <h2 className="alternate-heading">Industrial Solutions</h2>
            </div>
            <p className="body">
              In addition to automotive solutions, Pancon GmbH provides solutions for various industries as your partner for connector systems. With many years of experience and a clear focus on quality, we develop customized solutions for customers across different industries. We help you find the right connectors, support your projects, and unlock new potential – reliably, flexibly, and with a future-oriented approach.
            </p>
            <div className="flex as-top">
              <div className="two-thirds marg">
                <h3 className="as">Coffee Machine</h3>
                <p className="body as">
                  With the direct contact system, Pancon offers a product for a state-of-the-art flow sensor, specially developed for use in household and capsule coffee machines. The sensor impresses with its high reliability, flexible application possibilities, and full compliance with international standards.
                </p>
              </div>
              <div className="third marg flex center-h center-v">
                <img height={"256px"} width={"auto"} src={AS1}></img>
              </div>
            </div>
            <div className="flex as-top first">
              <div className="third marg flex center-h center-v">
                <img src={AS2}></img>
              </div>
              <div className="two-thirds marg">
                <h3 className="as">Water Pump</h3>
                <p className="body as">
                  This compact 3-pole connector was specially developed for use in electric water pumps. It impresses with high reliability, an assembly-friendly design, and a robust construction designed for continuous operation in technically demanding environments. Application areas: Electric water pumps in stationary or mobile applications, suitable for use in moist and vibration-prone environments, ensuring safe voltage and signal transmission in continuous operation.
                </p>
              </div>
            </div>
            <div className="flex as-top">
              <div className="two-thirds marg">
                <h3 className="as">Toilet</h3>
                <p className="body as">
                  This specially customized Pancon connector was developed to meet the requirements of high-quality sanitary systems and is used in luxury toilet solutions, among others. The robust yet compact design ensures reliable connections in confined installation spaces – ideal for use in innovative products with high-quality demands.
                </p>
              </div>
              <div className="third marg flex center-h center-v">
                <img src={AS3}></img>
              </div>
            </div>
            <div className="flex as-top">
              <div className="third marg flex center-h center-v">
                <img src={AS4}></img>
              </div>
              <div className="two-thirds">
                <h3 className="as">E-Bike Motor</h3>
                <p className="body as">
                  This compact drive unit was specially developed for use in modern e-bikes and offers powerful support with high reliability. A central part of the internal connection technology is a custom-tailored Pancon connector that ensures a secure and quick connection between the control electronics and the motor unit.
                </p>
              </div>
            </div>
            <div className="flex as-top">
              <div className="two-thirds marg">
                <h3 className="as">Fan</h3>
                <p className="body as">
                  This connector is part of a modern connectivity system, specially designed for the safe and reliable connection of electronic components in fans. Its compact design and clear color coding of contacts allow for quick and error-free assembly. High-quality processing ensures a durable connection even under demanding operating conditions. Integration into the housing protects electrical connections from external influences, ensuring smooth operation in industrial applications.
                </p>
              </div>
              <div className="third marg flex center-h center-v">
                <img src={AS5}></img>
              </div>
            </div>
            <div className="flex as-top">
              <div className="third marg flex center-h center-v">
                <img src={AS6}></img>
              </div>
              <div className="two-thirds marg">
                <h3 className="as">Fuel Dispenser</h3>
                <p className="body as">
                  This custom Pancon connector was specially developed for use in electronic modules of fuel dispenser systems. Its compact design and proven IDC connection technology (Insulation Displacement Connection) make the connector ideal for quick, solder-free wiring within control units. Typical applications: control and display modules in modern fuel dispensers, connections for control panels, sensors, and billing electronics, as well as applications with increased demands for continuous operation and system availability.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="less-bot section flex center-h">
          <div className="center-mob medium flex center-h">
            <div className="heading1-cont flex center-v center-h">
              <h2 className="alternate-heading">What do we offer?</h2>
            </div>
            <div
              onClick={(event) => this.changeCountry(event, "PD")}
              className={
                this.state.active === "PD"
                  ? "dist-country as active"
                  : "dist-country as"
              }
            >
              Product Development
            </div>
            <div
              onClick={(event) => this.changeCountry(event, "PM")}
              className={
                this.state.active === "PM"
                  ? "dist-country as active"
                  : "dist-country as"
              }
            >
              Project Management
            </div>
            <div
              onClick={(event) => this.changeCountry(event, "P")}
              className={
                this.state.active === "P"
                  ? "dist-country as active"
                  : "dist-country as"
              }
            >
              Prototyping
            </div>
            <div
              onClick={(event) => this.changeCountry(event, "SP")}
              className={
                this.state.active === "SP"
                  ? "dist-country as active"
                  : "dist-country as"
              }
            >
              Serial Production and Logistics
            </div>
          </div>
        </div>
        {this.state.active == "PD" ? (
          <div className="section flex center-h">
            <div className="medium flex">
              <div className="half">
                <p className="body">
                  At Pancon, Product Development is at the heart of our innovation strategy. From the initial idea to a market-ready product, we support our customers with customized solutions, technical expertise, and agile development. Our experienced team ensures your product ideas are implemented quickly, efficiently, and in line with the market. Rely on Pancon – your partner for future-oriented product development.
                </p>
              </div>
              <div className="half">
                <img className="img-full" src={AS2_1}></img>
              </div>
            </div>
          </div>
        ) : null}
        {this.state.active == "PM" ? (
          <div className="section flex center-h">
            <div className="medium flex">
              <div className="half">
                <p className="body">
                  After product development, Pancon takes over Project Management to safely bring your idea to life. We coordinate all project phases – from planning to production to delivery – precisely and transparently. With modern tools, clear processes, and a dedicated team, we ensure on-time results, cost control, and top quality. Pancon stands for reliable project management that takes the load off your shoulders and successfully brings your product to market.
                </p>
              </div>
              <div className="half">
                <img className="img-full" src={AS2_2}></img>
              </div>
            </div>
          </div>
        ) : null}
        {this.state.active == "P" ? (
          <div className="section flex center-h">
            <div className="medium flex">
              <div className="half">
                <p className="body">
                  In the prototyping phase, we turn your concepts into tangible models. Using state-of-the-art manufacturing technologies and iterative testing, we gain valuable insights early on – for functional, cost-effective, and market-ready products.
                </p>
              </div>
              <div className="half">
                <img className="img-full" src={AS2_3}></img>
              </div>
            </div>
          </div>
        ) : null}
        {this.state.active == "SP" ? (
          <div className="section flex center-h">
            <div className="medium flex">
              <div className="half">
                <p className="body">
                  In serial production, we guarantee top quality and efficiency. With a strong network and optimized logistics processes, we deliver your products quickly and reliably to customers worldwide.
                </p>
              </div>
              <div className="half">
                <img className="img-full" src={AS2_4}></img>
              </div>
            </div>
          </div>
        ) : null}
        <div className="section full about-1 new-margin flex center-h center-v">
          <div className="half about-img-2"></div>
          <div className="half red-bg less">
            <h2>Which technologies do we offer?</h2>
            <ul className="body">
              <li>Moulding and overmoulding of connectors and ECU applications</li>
              <li>Assembly of connector applications</li>
              <li>Customer-specific solutions</li>
              <li>Pressfit technology</li>
              <li>THR/SMD connectors</li>
              <li>IDC applications</li>
              <li>Crimp solutions</li>
              <li>High-temperature plastic solutions</li>
              <li>Glow wire solutions</li>
              <li>Jumper switches</li>
              <li>LED/LCD</li>
            </ul>
          </div>
        </div>
        <div className="less-bot section flex center-h">
          <div className="center-mob medium flex center-h">
            <div className="heading1-cont flex center-v center-h">
              <h2 className="alternate-heading">Which production solutions do we offer?</h2>
            </div>
            <div
              onClick={(event) => this.changeCountry2(event, "S")}
              className={
                this.state.active_2 === "S"
                  ? "dist-country as active"
                  : "dist-country as"
              }
            >
              Stamping
            </div>
            <div
              onClick={(event) => this.changeCountry2(event, "M")}
              className={
                this.state.active_2 === "M"
                  ? "dist-country as active"
                  : "dist-country as"
              }
            >
              Molding
            </div>
            <div
              onClick={(event) => this.changeCountry2(event, "O")}
              className={
                this.state.active_2 === "O"
                  ? "dist-country as active"
                  : "dist-country as"
              }
            >
              Overmolding
            </div>
            <div
              onClick={(event) => this.changeCountry2(event, "AA")}
              className={
                this.state.active_2 === "AA"
                  ? "dist-country as active"
                  : "dist-country as"
              }
            >
              Automation Assembling
            </div>
          </div>
        </div>
        {this.state.active_2 == "S" ? (
          <div className="section flex center-h">
            <div className="medium flex">
              <div>
                <p className="body">
                  With our powerful stamping technology, we produce high-quality metal parts in large quantities – fast, efficiently, and with maximum precision. Pancon relies on modern press systems and intelligent tools for complex geometries and highest dimensional accuracy. Whether small or large series: our stamped parts meet the highest quality standards.
                </p>
              </div>
            </div>
          </div>
        ) : null}
        {this.state.active_2 == "AA" ? (
          <div className="section flex center-h">
            <div className="medium flex">
              <div>
                <p className="body">
                  Our solutions in automation assembling enable fully automated assembly processes. With precisely coordinated systems, we increase efficiency, reduce costs, and ensure consistently high product quality – even with large quantities.
                </p>
              </div>
            </div>
          </div>
        ) : null}
        {this.state.active_2 == "M" ? (
          <div className="section flex center-h">
            <div className="medium flex">
              <div>
                <p className="body">
                  Our molding technology enables the production of complex plastic components with high dimensional accuracy. Using modern injection molding processes, we produce functional parts with optimal mechanical properties – ideal for technical applications, electronics, or automotive. Pancon offers precise plastic processing from a single source.
                </p>
              </div>
            </div>
          </div>
        ) : null}
        {this.state.active_2 == "O" ? (
          <div className="section flex center-h">
            <div className="medium flex">
              <div>
                <p className="body">
                  With overmolding, we combine different materials into a single unit – for example, metal carriers with protective plastic layers. This process ensures improved functionality, durability, and design freedom. Whether for electrical insulation, seals, or ergonomic surfaces: Pancon provides customized overmolding solutions for complex requirements.
                </p>
              </div>
            </div>
          </div>
        ) : null}
        <div className="section flex center-h">
          <div className="medium flex">
            <div className="half flex center-v center-h">
              <p className="eye-catcher accent">Pancon – Connectivity for a Connected World</p>
              <p className="body s-18">
                Industry 4.0, automation, and IoT place high demands on connection systems. Our solutions provide companies in a wide range of industries with the necessary performance to meet these requirements:
              </p>
            </div>
            <div className="half flex center-v center-h col">
              <Link className="default diff-1" to="/en/contact">
                <span>Contact us now</span>
              </Link>
              <p className="body s-18">We look forward to your inquiry!</p>
            </div>
          </div>
        </div>
        <FooterEN />
      </div>
    );
  }
}

export default AutomotiveSolutions_New_EN;
